import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-flex align-items-center" };
const _hoisted_2 = { class: "btn" };
const _hoisted_3 = {
    key: 1,
    class: "badge text-bg-secondary"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-4" };
const _hoisted_6 = { class: "mb-4" };
const _hoisted_7 = {
    key: 0,
    class: "w-100 text-center mb-3"
};
const _hoisted_8 = { class: "w-100 text-center small" };
const _hoisted_9 = { class: "row justify-content-center" };
const _hoisted_10 = { class: "col-lg-4" };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = {
    key: 1,
    class: "pt-3 mt-3",
    style: { "background-color": "#000000" }
};
const _hoisted_14 = { class: "row g-0" };
const _hoisted_15 = { class: "col-12 col-lg-6" };
const _hoisted_16 = { class: "fw-bold text-white text-center mb-1" };
const _hoisted_17 = { class: "fw-bold text-secondary fw-bold text-center" };
const _hoisted_18 = { class: "col-12 col-lg-6" };
const _hoisted_19 = { class: "fw-bold text-white text-center mb-1" };
const _hoisted_20 = {
    key: 0,
    class: "fw-bold text-secondary fw-bold text-center"
};
const _hoisted_21 = { class: "row m-0 mt-4 justify-content-center" };
const _hoisted_22 = { class: "col-12 p-0 d-flex flex-wrap justify-content-center" };
const _hoisted_23 = ["onClick"];
const _hoisted_24 = { class: "small bg-white text-center pantone-inner-box" };
const _hoisted_25 = { class: "font-weight-bold border-bottom d-block" };
const _hoisted_26 = { class: "small d-block" };
const _hoisted_27 = { class: "small d-block" };
const _hoisted_28 = { class: "small d-block" };
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PantoneColorPicker',
    props: {
        id: Number,
        initialHexColor: String,
        showColorBox: {
            type: Boolean,
            default: false
        },
        selectForHexBase: {
            type: String,
            default: null
        }
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const currentColor = ref(null);
        const colors = ref([]);
        const filteredColors = ref([]);
        const modal = ref();
        onMounted(() => {
            loadColors();
        });
        function loadColors() {
            axios.post(route('panoneColors.load'), {})
                .then(function (response) {
                colors.value = response.data;
                filteredColors.value = colors.value;
                if (props.initialHexColor) {
                    currentColor.value = colors.value.find((color) => color.hex === props.initialHexColor) || null;
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function searchColor(searchstring) {
            if (searchstring == '') {
                filteredColors.value = colors.value;
            }
            else {
                filteredColors.value = colors.value.filter(color => color.name.toLowerCase().includes(searchstring.toLowerCase()) || color.hex.toLowerCase().includes(searchstring.toLowerCase()));
            }
        }
        function selectColor(color) {
            currentColor.value = {
                id: color.id,
                name: color.name,
                hex: color.hex,
                red: color.red,
                green: color.green,
                blue: color.blue,
                cyan: color.cyan,
                magenta: color.magenta,
                yellow: color.yellow,
                key: color.key,
                coated: color.coated
            };
            emit('update', currentColor.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    (props.showColorBox && currentColor.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: _normalizeStyle([{ "width": "50px", "height": "50px" }, { backgroundColor: currentColor.value.hex }]),
                            class: "rounded"
                        }, null, 4))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", _hoisted_2, [
                        _createElementVNode("img", {
                            src: "/images/configurator/colorpickericon.png",
                            onClick: _cache[0] || (_cache[0] = ($event) => (modal.value.open($event)))
                        })
                    ]),
                    (currentColor.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(currentColor.value.name) + " " + _toDisplayString(currentColor.value.coated), 1))
                        : _createCommentVNode("", true)
                ]),
                (props.showColorBox && currentColor.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(currentColor.value.hex), 1))
                    : _createCommentVNode("", true),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    size: 'md'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(t)('Pantone-Farben')), 1),
                        _createElementVNode("div", _hoisted_6, [
                            (currentColor.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("span", {
                                        class: "border-3 rounded px-3 py-2",
                                        style: _normalizeStyle({ borderStyle: 'solid', borderWidth: 5 + 'px', borderColor: currentColor.value.hex })
                                    }, [
                                        _createTextVNode("Aktuelle " + _toDisplayString(_unref(t)('Farbe')) + ": ", 1),
                                        _createElementVNode("strong", null, _toDisplayString(currentColor.value.name) + " " + _toDisplayString(currentColor.value.coated), 1)
                                    ], 4)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("p", null, _toDisplayString(_unref(t)('Wählen Sie Ihre gewünschte Pantone-Farbe aus')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("input", {
                                            type: "text",
                                            class: "form-control border",
                                            placeholder: _unref(t)('Suche nach Pantone-Nummer oder Hex-Wert'),
                                            onKeyup: _cache[1] || (_cache[1] = ($event) => (searchColor($event.target.value)))
                                        }, null, 40, _hoisted_12)
                                    ])
                                ])
                            ]),
                            (props.selectForHexBase)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('Original - Hexwert')), 1),
                                            _createElementVNode("p", _hoisted_17, _toDisplayString(props.selectForHexBase), 1),
                                            _createElementVNode("div", {
                                                class: "w-100",
                                                style: _normalizeStyle([{ "height": "50px" }, { backgroundColor: props.selectForHexBase }])
                                            }, null, 4)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('Ziel - Pantone')), 1),
                                            (currentColor.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(currentColor.value.name) + " " + _toDisplayString(currentColor.value.coated) + ", " + _toDisplayString(currentColor.value.hex), 1))
                                                : _createCommentVNode("", true),
                                            (currentColor.value)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    class: "w-100",
                                                    style: _normalizeStyle([{ "height": "50px" }, { backgroundColor: currentColor.value.hex }])
                                                }, null, 4))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredColors.value, (color) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            class: "pantone-box",
                                            style: _normalizeStyle({ backgroundColor: color.hex }),
                                            onClick: ($event) => (selectColor(color)),
                                            "data-dismiss": "modal"
                                        }, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("div", {
                                                    class: "w-100",
                                                    style: _normalizeStyle({ height: 15 + 'px', backgroundColor: color.hex })
                                                }, null, 4),
                                                _createElementVNode("span", _hoisted_25, [
                                                    _createTextVNode(_toDisplayString(color.name) + " " + _toDisplayString(color.coated), 1),
                                                    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
                                                ]),
                                                _createElementVNode("span", _hoisted_26, [
                                                    _cache[3] || (_cache[3] = _createElementVNode("strong", null, "RGB", -1)),
                                                    _createTextVNode(" " + _toDisplayString(color.red) + " " + _toDisplayString(color.green) + " " + _toDisplayString(color.blue), 1)
                                                ]),
                                                _createElementVNode("span", _hoisted_27, [
                                                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "HEX", -1)),
                                                    _createTextVNode(" " + _toDisplayString(color.hex), 1)
                                                ]),
                                                _createElementVNode("span", _hoisted_28, [
                                                    _cache[5] || (_cache[5] = _createElementVNode("strong", null, "CMYK", -1)),
                                                    _createTextVNode(" " + _toDisplayString(color.cyan) + " " + _toDisplayString(color.magenta) + " " + _toDisplayString(color.yellow) + " " + _toDisplayString(color.key), 1)
                                                ]),
                                                _createElementVNode("div", {
                                                    class: "w-100",
                                                    style: _normalizeStyle({ height: '15px', backgroundColor: color.hex })
                                                }, null, 4)
                                            ])
                                        ], 12, _hoisted_23));
                                    }), 256))
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
